<template>
  <div v-if="!loading">
    <div class v-if="eventToManageForDisplay && userPermissions.manageEvents && canViewEvent">
      <!--Header-->
      <div class="custom-menu menu pt-2 pb-4 px-0 px-md-5 pt-md-5 pb-md-3 m-0">
        <div class="row w-100">
          <div class="col-12 d-md-none d-flex justify-content-end pt-1">
            <b-btn class="btn" variant="link" v-b-modal.event-delete v-if="userPermissions.deleteEvents">
              <i class="fas fa-trash text-danger"></i>
            </b-btn>
            <router-link class="close px-3 d-md-none d-block" to="/events">&times;</router-link>
          </div>
          <div class="col-md-6 col-12 text-md-left text-center pt-md-0 pt-3">
            <h3 class="d-block text-white mb-0">
              {{ eventToManageForDisplay.property.name }}
              <br />
            </h3>
            <p class="text-white mb-0 mt-2">
              <span>Date &amp; Time:&nbsp;</span><span>{{ eventToManageForDisplay.dateOccurredLocal | formatDate
                }}</span>
            </p>
            <p class="text-white">
              <span>Incident:&nbsp;</span><span>#{{ eventToManageForDisplay.number}}</span>
            </p>
          </div>
          <div class="col text-right d-md-block d-none">
            <b-btn variant="primary" @click="incidentReportVisible = true">Incident Report</b-btn>
            <b-btn v-if="eventToManage && !eventToManage.isSopComplete" class="btn" variant="warning" @click="doResumeSop()">
              <i class="fas fa-play-circle"></i> Resume SOP
            </b-btn>
            <b-btn class="btn" variant="danger" v-b-modal.event-delete v-if="userPermissions.deleteEvents">
              Delete
            </b-btn>
            <b-btn class="btn" variant="light" @click="closeEventManage">
              Close
            </b-btn>
            <!--router-link class="btn btn-light" to="/events">Close</router-link-->
          </div>
        </div>
      </div>
      <b-tabs class="custom-tabs sticky-tabs mb-5" v-model="tabIndex" lazy>
        <b-tab title="Details" class="py-0">
          <template #title>
            <i class="fas fa-info-circle d-md-none d-inline p-md-0 px-2"></i> <span
              class="d-md-inline d-none">Details</span>
          </template>
          <div class="px-lg-4 px-3">
            <div class="row mt-xl-4 mt-md-3 mt-3">
              <div class="col-xl-3 col-md-12 px-xl-3 px-md-4 px-3 mb-xl-0 mb-md-4">
                <div class="card p-3 shadow">
                  <h5 class="mt-2 mb-3">Event Details</h5>
                  <div class="list-group">
                    <div class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <strong>Property</strong>
                        </div>
                        <div class="col">
                          {{ eventToManageForDisplay.property.name }}:
                          {{ eventToManageForDisplay.property.address.streetAddress1 }}
                          {{ eventToManageForDisplay.property.address.city }}, {{
                          eventToManageForDisplay.property.address.state }}
                        </div>
                      </div>
                    </div>
                    <div class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <strong>Severity</strong>
                        </div>
                        <div class="col">{{ eventToManageForDisplay.severityLevel }}</div>
                      </div>
                    </div>
                    <div class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <strong>Involves Emergency Services</strong>
                        </div>
                        <div class="col">{{ eventToManageForDisplay.emergencyServicesInvolved }}</div>
                      </div>
                    </div>
                    <div class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <strong>Type</strong>
                        </div>
                        <div class="col">{{ eventToManageForDisplay.type }}</div>
                      </div>
                    </div>
                    <div class="list-group-item">
                      <div class="row">
                        <div class="col-12">
                          <strong>Category</strong>
                        </div>
                        <div class="col">{{ eventToManageForDisplay.category }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card p-3 shadow mt-4">
                  <h5 class="mt-2 mb-3">Privacy Settings</h5>
                  <div class="bg-white border rounded px-3">
                    <b-tooltip target="visibleTo" non-interactive no-fade>Select or Unselect multiple roles by pressing
                      control key [ctrl].</b-tooltip>
                    <div style="cursor: pointer" id="visibleToLabel" @click="toggleVisibleToExpanded">
                      <label style="cursor: pointer" class="control-label mt-2">Visible Only to Roles <span>({{
                          visibleToRolesCount }})</span></label>
                      <span><i :class="visibleToRolesExpanded ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i></span>
                      <i id="visibleTo" class="fas fa-question-circle ml-1 mt-3"></i>
                    </div>
                    <b-form-select v-if="visibleToRolesExpanded" multiple :select-size="8"
                      v-model="eventChangeDetails.visibleToPositionTypeIds" :options="allPositionTypesListOptions">
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12 col-12 px-xl-3 px-md-4 px-3 mb-xl-0 mb-md-4 mb-4">
                <div class="card p-3 shadow">
                  <div class="row no-gutters">
                    <div class="col-12 field">
                      <b-form>
                        <b-form-group class="px-2">
                          <b-form-row>
                            <h5 class="mt-2 mb-3">Event Status</h5>
                            <b-form-select :options="eventStatuses" v-model="eventChangeDetails.status" :disabled="eventToManage.isEventStatusLockedByClaimStatus" :title="eventToManage.isEventStatusLockedByClaimStatus ? 'This event status is locked until the related claim is closed.' : null">
                            </b-form-select>
                          </b-form-row>
                          <b-form-row>
                            <label class="control-label mt-3">Location</label>
                            <b-input class="form-control" placeholder="Location"
                              v-model="eventChangeDetails.location" />
                          </b-form-row>
                          <b-form-row>
                            <label class="control-label mt-3">Management Report</label>
                            <b-form-textarea rows="5" placeholder="Summary of event."
                              v-model="eventChangeDetails.summary"></b-form-textarea>
                          </b-form-row>
                        </b-form-group>
                        <!--
                    <b-form-group style="position: relative" v-if="eventChangeDetails.visibleToPositionTypeIds">
                      <multiselect v-model="eventChangeDetails.visibleToPositionTypeIds" :options="allPositionTypesListOptions" track-by="value" label="text" placeholder="Search..." :multiple="true" :searchable="true" :close-on-select="false">
                        <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span></template>
                      </multiselect>
                    </b-form-group>
                    -->
                      </b-form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-right">
                      <b-btn variant="primary" content="Save" :disabled="!eventDetailsChanged"
                        @click="doSaveDetails()">Save</b-btn>
                    </div>
                  </div>
                </div>
                <div class="card p-3 shadow mt-4">
                  <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
                    <h5 class="mb-0">SOP Questions <span v-if="!eventToManageForDisplay.isSopComplete" style="color:red">(incomplete)</span></h5>
                    <b-btn v-if="eventToManage && !eventToManage.isSopComplete" size="sm" variant="warning" @click="doResumeSop()">
                      <i class="fas fa-play-circle"></i> Resume SOP
                    </b-btn>
                  </div>
                  <div class="list-group">
                    <div class="list-group-item" v-for="question in eventToManageForDisplay.sopQuestions"
                      v-bind:key="question.id">
                      <div class="row">
                        <div class="col-12 pb-2">
                          <strong>{{ question.text }}</strong>
                        </div>
                        <div class="col-12">
                          <div>{{ question.answer }}</div>
                          <div v-if="question.typeDescriptor === 'Checklist'">
                            <b-form-checkbox disabled v-for="checklistItem in question.checklistItems"
                              v-bind:key="checklistItem.text" v-model="checklistItem.checked">{{ checklistItem.text
                              }}</b-form-checkbox>
                          </div>
                          <div v-if="question.images != null && question.typeDescriptor === 'ImageUpload'">
                            <div class="image-list mt-1">
                              <div class="card col mb-1" v-for="(image, i) in question.images" :key="i"
                                @click="questionIndex = i">
                                <FileThumbnail :thumbnail-url="image.thumbnailPublicUrl" :full-url="image.publicUrl" file-type="image" img-class="card-img" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-md-12 col-12 px-xl-3 px-md-4 px-3 mb-xl-0 mb-md-3 mb-3">
                <div class="card p-3 shadow">
                  <div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <h5 class="m-0">Event Images</h5>
                      <b-btn class="btn btn-success" @click="imageUploadModalOpen = true">
                        <i class="fas fa-plus"></i> Add
                      </b-btn>
                    </div>
                    <div v-if="imagesForEvent.length > 0" class="image-list mt-1">
                      <div class="card col mb-1 position-relative" v-for="(image, i) in imagesForEvent" :key="image.id" @click="index = i" style="cursor:pointer;">
                        <FileThumbnail :thumbnail-url="image.thumbnailPublicUrl" :thumbnail-micro-url="image.thumbnailMicroPublicUrl" :full-url="image.publicUrl" file-type="image" img-class="card-img" size="micro" />
                        <b-btn v-if="canViewQRCode && image.qrCodePublicUrl" variant="light" size="sm"
                               class="qr-btn position-absolute"
                               style="bottom:4px;right:4px;padding:2px 5px;opacity:0.85;"
                               @click.stop="showQRCode(image)"
                               title="View QR Code">
                          <i class="fas fa-qrcode"></i>
                        </b-btn>
                      </div>
                    </div>
                    <div v-else class="no-images-placeholder mt-1">
                      <i class="fas fa-images"></i>
                      <span>No images uploaded</span>
                    </div>
                  </div>
                </div>
                <!-- SOP Question Media -->
                <div v-if="sopQuestionImages.length || sopQuestionVideos.length || sopMediaLoading"
                     class="card p-3 shadow mt-3">
                  <h5 class="m-0 mb-2">SOP Question Media
                    <b-spinner v-if="sopMediaLoading" small class="ml-2 text-muted"></b-spinner>
                  </h5>
                  <div v-if="sopQuestionImages.length">
                    <p class="small text-muted font-weight-bold mb-1">Images</p>
                    <div class="image-list">
                      <div class="card col mb-1 position-relative" v-for="(image, i) in sopQuestionImages" :key="image.id"
                           @click="sopImageIndex = i" style="cursor:pointer;">
                        <FileThumbnail :thumbnail-url="image.thumbnailPublicUrl" :thumbnail-micro-url="image.thumbnailMicroPublicUrl" :full-url="image.publicUrl"
                          file-type="image" img-class="card-img" size="micro" />
                        <b-btn v-if="canViewQRCode && image.qrCodePublicUrl" variant="light" size="sm"
                               class="qr-btn position-absolute"
                               style="bottom:4px;right:4px;padding:2px 5px;opacity:0.85;"
                               @click.stop="showQRCode(image)"
                               title="View QR Code">
                          <i class="fas fa-qrcode"></i>
                        </b-btn>
                      </div>
                    </div>
                  </div>
                  <div v-if="sopQuestionVideos.length" :class="{ 'mt-3': sopQuestionImages.length }">
                    <p class="small text-muted font-weight-bold mb-1">Videos</p>
                    <div class="image-list">
                      <div class="card col mb-1 position-relative" v-for="(video, i) in sopQuestionVideos" :key="video.id">
                        <FileThumbnail
                          :thumbnail-url="video.thumbnailPublicUrl"
                          :thumbnail-micro-url="video.thumbnailMicroPublicUrl"
                          :full-url="video.publicUrl"
                          :processed-video-url="video.videoProcessingStatus === 'Complete' ? video.processedVideoPublicUrl : null"
                          :processing-status="video.videoProcessingStatus"
                          file-type="video"
                          img-class="card-img"
                          size="micro"
                          @play="openSopVideo(i)" />
                        <b-btn v-if="canViewQRCode && video.qrCodePublicUrl" variant="light" size="sm"
                               class="qr-btn position-absolute"
                               style="bottom:4px;right:4px;padding:2px 5px;opacity:0.85;"
                               @click.stop="showQRCode(video)"
                               title="View QR Code">
                          <i class="fas fa-qrcode"></i>
                        </b-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <vue-gallery-slideshow :images="imagesForGallery" :index="index"
                @close="index = null"></vue-gallery-slideshow>
              <vue-gallery-slideshow :images="imagesForQuestions" :index="questionIndex"
                @close="questionIndex = null"></vue-gallery-slideshow>
              <vue-gallery-slideshow :images="sopImageGallery" :index="sopImageIndex"
                @close="sopImageIndex = null"></vue-gallery-slideshow>
              <!-- <div class="image-list d-flex flex-wrap mt-1">
            <div class="card col mb-1" v-for="(image , i) in imagesForEvent" v-bind:key="image.id" @click="index = i">
              <b-img :src="image.publicUrl" class="card-img" @click="doShowFullImage(image)" />
            </div>
          </div> -->
            </div>
          </div>
        </b-tab>
        <b-tab title="People" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3">
          <template #title>
            <i class="fas fa-users d-md-none d-inline  p-md-0 px-2"></i><span class="d-md-inline d-none">People</span>
          </template>
          <eventPeople :eventId="this.eventId" />
        </b-tab>
        <b-tab title="Documentation" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3">
          <template #title>
            <i class="fas fa-file d-md-none d-inline  p-md-0 px-2"></i><span class="d-md-inline d-none">Documents</span>
          </template>
          <div class="d-flex justify-content-end pt-3">
            <b-button v-if="canViewQRCode" variant="outline-primary" size="sm" @click="createOrShowFileShare">
              <i class="fas fa-share-alt mr-1"></i> Share Files
            </b-button>
          </div>
          <!-- Resources Component with SOP media injected via slot -->
          <div class="resources-embedded">
          <resources ref="resources" :event-id="eventToManageForDisplay.id" :folder-id="folderId">

            <!-- SOP Question Images -->
            <div v-if="sopQuestionImages.length" class="row mb-4">
              <div class="col-12">
                <div class="divider"></div>
                <p class="mb-2"><strong>SOP Question Images</strong></p>
                <div class="row justify-content-start flex-wrap no-gutters mx-n2">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-12 px-1 mb-2"
                       v-for="(image, i) in sopQuestionImages" :key="image.id">
                    <div class="card document-card" @click="sopImageIndex = i" style="cursor:pointer;">
                      <FileThumbnail :thumbnail-url="image.thumbnailPublicUrl" :full-url="image.publicUrl"
                        file-type="image" img-class="card-img-top" style="height:120px; object-fit:cover;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SOP Question Videos -->
            <div v-if="sopQuestionVideos.length" class="row mb-4">
              <div class="col-12">
                <div class="divider"></div>
                <p class="mb-2"><strong>SOP Question Videos</strong></p>
                <div class="row justify-content-start flex-wrap no-gutters mx-n2">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-12 px-1 mb-2"
                       v-for="(video, i) in sopQuestionVideos" :key="video.id">
                    <div class="card document-card">
                      <FileThumbnail
                        :thumbnail-url="video.thumbnailPublicUrl"
                        :full-url="video.publicUrl"
                        :processed-video-url="video.videoProcessingStatus === 'Complete' ? video.processedVideoPublicUrl : null"
                        :processing-status="video.videoProcessingStatus"
                        file-type="video"
                        img-class="card-img-top"
                        style="height:120px; overflow:hidden;"
                        @play="openSopVideo(i)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </resources>
          </div>
        </b-tab>
        <b-tab title="Correspondence" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3" v-if="userPermissions.viewCorrespondence">
          <event-correspondence-tab :event-id="eventId" />
        </b-tab>
        <b-tab title="Expenses" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3">
          <template #title>
            <i class="fas fa-dollar-sign d-md-none d-inline  p-md-0 px-2"></i><span class="d-md-inline d-none">Expenses</span>
          </template>
          <div class="d-flex justify-content-between align-items-end my-3">
            <h5 class="mb-1">Expenses</h5>
            <div>
              <b-btn variant="success" @click="addExpense()">
                <i class="fas fa-plus mr-1"></i>Add
              </b-btn>
              <!-- <router-link title="Add Expenses"
                v-if="damageRelatedExpenses == null || damageRelatedExpenses.length === 0"
                :to="{ name: 'AddEditDamages', params: { eventId: eventToManage.id, propertyId: eventToManage.propertyId }}">
                <b-btn variant="success">
                  <i class="fas fa-plus mr-1"></i>Add
                </b-btn>
              </router-link>
              <router-link title="Edit Expenses" v-else
                :to="{ name: 'AddEditDamages', params: { eventId: eventToManage.id, propertyId: eventToManage.propertyId }}">
                <b-btn variant="primary">
                  <i class="fas fa-pencil mr-1"></i>Edit
                </b-btn>
              </router-link> -->
            </div>
          </div>
          <div v-if="damageRelatedExpenses == null || damageRelatedExpenses.length === 0"
            class="no-data d-flex justify-content-center align-items-center py-5 text-black-50">No expenses to display</div>
          <div v-else>
            <table class="table b-table table rg-table table-bordered">
              <thead>
                <tr>
                  <th class="col-2"><strong>Type</strong></th>
                  <th class="col-2"><strong>Category</strong></th>
                  <th class="col-3"><strong>Name (Vendor/Other)</strong></th>
                  <th class="col-3"><strong>Details</strong></th>
                  <th class="col-2"><strong>Amount</strong></th>
                  <th class="col-1 text-center"><strong>Actions</strong></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(expense, index) in damageRelatedExpenses" :key="index">
                  <td class="col-2">{{ expense.expenseSource == 0 ? 'Vendor': 'Other' }}</td>
                  <td class="col-2">{{ expense.costCategory }}</td>
                  <td class="col-3">{{ expense.expenseSource == 0 ? expense.vendorName: expense.otherName }}</td>
                  <td class="col-3">{{ expense.detail }}</td>
                  <td class="col-2">{{ expense.amount | formatCurrency }}</td>
                  <td class="col-1">
                    <div class="d-flex align-items-center justify-content-center">
                      <b-btn variant="link" size="sm" @click="editExpense(expense, index)" class="p-1 mr-1">
                        <i class="fas fa-edit text-primary"></i>
                      </b-btn>
                      <b-btn variant="link" size="sm" @click="deleteExpense(expense, index)" class="p-1">
                        <i class="fas fa-trash text-danger"></i>
                      </b-btn>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right" colspan="4"><strong>Total Expenses</strong></td>
                  <td><span class="text-primary">({{ totalExpenses | formatCurrency}})</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
        <b-tab title="Claim" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3" v-if="userPermissions.manageInsuranceClaims">
          <template #title>
            <i class="fas fa-tasks d-md-none d-inline p-md-0 px-2"></i><span class="d-md-inline d-none">Claim</span>
          </template>
          <div class="d-flex justify-content-between align-items-end my-3">
            <h5 class="mb-1 d-none">Claims List</h5>
            <router-link title="Add Claim" v-if="claims == null || claims.length === 0"
              :to="{ name: 'AddEditClaim', params: { eventId: eventToManage.id, claimId: null, propertyId: eventToManage.propertyId }}">
              <b-btn variant="success">
                <i class="fas fa-plus mr-1"></i>Create Claim
              </b-btn>
            </router-link>
          </div>
          <div class="d-flex flex-column no-claims" v-if="claims">
            <div class="px-3" v-for="claim in claims" v-bind:key="claim.id">
              <div class="row">
                <!--Claim Info-->
                <div class="col-xl-4 col-lg-5 card p-4 shadow brand-dark-blue-bg">
                  <div class="row">
                    <div class="col-8">
                      <h5>
                        <span class="badge badge-pill badge-secondary pt-1">
                          <span>Claim #</span>
                          <span>{{ claim.claimNumber }}</span>
                        </span>
                      </h5>
                      <h3 class="mb-0 text-white"><strong>{{ claim.title }}</strong></h3>
                      <div class="d-flex text-light flex-wrap">
                        <span>{{ claim.claimStatusString }}</span>
                        <span class="px-2">&bull;</span>
                        <span>{{ claim.claimTypeString }}</span>
                        <span class="px-2">&bull;</span>
                        <span>{{ claim.claimDate | formatDateNoTime }}</span>
                      </div>
                    </div>
                    <div class="text-right col d-lg-none d-md-block">
                      <router-link
                        class="btn btn-primary"
                        :to="{ name: 'AddEditClaim', params: { eventId: eventToManage.id, claimId: claim.id, propertyId: eventToManage.propertyId } }"
                        >
                        <i class="fas fa-pencil"></i>&nbsp;<span>Edit Claim</span>
                      </router-link>
                    </div>
                  </div>
                  <div class="mt-3">
                    <label class="label m-0 text-light"><strong>Reason</strong></label>
                    <p class="text-white">{{ claim.reason }}</p>
                  </div>
                  <div class="card bg-white-10 mt-3">
                    <div class="card-body">
                      <div class="border-left border-left-3 border-danger pl-3 py-1">
                        <label class="label mb-1 mr-4 text-white-50"><strong>Total Incurred Loss (Gross Loss)</strong></label>
                        <h4 class="text-white">{{ claim.totalIncurredLoss | formatCurrency }}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="card bg-white-10 mt-2">
                    <div class="card-body">
                      <div class="border-left border-left-3 border-primary pl-3 py-1">
                        <label class="label mb-1 mr-4 text-white-50"><strong>Total Covered Incurred Loss</strong></label>
                        <h4 class="text-white">{{ claim.coveredIncurredLoss | formatCurrency }}</h4>
                      </div>
                    </div>
                  </div>  
                  <div class="card bg-white-10 mt-2">
                    <div class="card-body">
                      <div class="border-left border-left-3 border-warning pl-3 py-1">
                        <label class="label mb-1 mr-4 text-white-50"><strong>Total Insured Retained Loss</strong></label>
                        <h4 class="text-white">{{ claim.insuredRetainedLoss | formatCurrency }}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="card bg-white-10 mt-2">
                    <div class="card-body">
                      <div class="border-left border-left-3 border-success pl-3 py-1">
                        <label class="label mb-1 mr-4 text-white-50"><strong>Total Paid by Insurance</strong></label>
                        <h4 class="text-white">{{ claim.totalPaidByInsurance | formatCurrency }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Policies / Untracked Policy-->
                <div class="col-xl-8 col-lg-7 py-3 px-lg-5 px-3">
                  <div>
                    <div class="text-right d-lg-block d-md-none">
                      <router-link
                        class="btn btn-primary"
                        :to="{ name: 'AddEditClaim', params: { eventId: eventToManage.id, claimId: claim.id, propertyId: eventToManage.propertyId } }"
                        >
                        <i class="fas fa-pencil"></i>&nbsp;<span>Edit Claim</span>
                      </router-link>
                    </div>
                  </div>
                  <div v-if="claim.claimType === 0 || claim.claimType === 2 || claim.claimType === 4 || claim.claimType === 5">
                    <div v-if="claim.claimPolicies || claim.selectedPolicies || claim.containerId" class="mb-4 pb-3 border-bottom">
                      <label class="mr-3 d-flex mb-3">
                        <span class="fa-stack">
                          <i class="fas fa-circle fa-stack-2x text-secondary"></i>
                          <i class="fas fa-building fa-stack-1x fa-inverse"></i>
                        </span>
                        <h5><strong class="ml-1 text-dark">Policies</strong></h5>
                      </label>
                      <!-- Container mode: show container info + layer allocations -->
                      <div v-if="claim.containerId">
                        <div class="card bg-light mb-3">
                          <div class="card-body pb-1">
                            <div class="row">
                              <div class="col-12 mb-2">
                                <label class="label">Policy Container</label>
                                 <h6>{{ claim.containerName || claim.containerId }}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="claim.layerAllocations && claim.layerAllocations.length > 0">
                          <h6 class="font-weight-bold mb-2">Layer Allocations</h6>
                          <b-table-simple small bordered responsive>
                            <b-thead>
                              <b-tr>
                                <b-th>Layer</b-th>
                                <b-th>Carrier</b-th>
                                <b-th>Share %</b-th>
                                <b-th>Allocated Amount</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr v-for="alloc in claim.layerAllocations" :key="alloc.layerId">
                                 <b-td>{{ alloc.layerName || alloc.layerId }}</b-td>
                                 <b-td>{{ alloc.carrierName }}</b-td>
                                 <b-td>{{ (alloc.participationPercent * 100).toFixed(1) }}%</b-td>
                                <b-td>{{ alloc.allocatedAmount | formatCurrency }}</b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </div>
                      <!-- Individual policies mode -->
                      <div v-else-if="claim.selectedPolicies && claim.selectedPolicies.filter(p => p !== null).length > 0">
                        <div v-for="policy in claim.selectedPolicies.filter(p => p !== null)" :key="policy.id">
                          <div class="card bg-light mb-2">
                            <div class="card-body pb-1">
                              <div class="row">
                                <div class="col-12 mb-2">
                                  <h6 class="label text-dark mb-0">{{policy.policyNumber}}</h6>
                                  <h5>{{policy.name}}</h5>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Carrier Name</label>
                                  <h6>{{policy.carrierName}}</h6>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Adjuster Name</label>
                                  <h6>{{policy.adjusterName}}</h6>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Adjuster Email</label>
                                  <h6>{{policy.adjusterEmail}}</h6>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Contact #</label>
                                  <h6>{{policy.adjusterPhoneNumber}}</h6>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Deductible Paid</label>
                                  <h6>{{policy.deductiblePaid | formatCurrency}}</h6>
                                </div>
                                <div class="col-4 mb-2">
                                  <label class="label">Amount Received</label>
                                  <h6>{{policy.amountReceived | formatCurrency}}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- No policies attached -->
                      <div v-else>
                        <span class="text-muted small">No policies attached.</span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div>
                      <label class="mr-3 d-flex mb-3">
                        <span class="fa-stack">
                          <i class="fas fa-circle fa-stack-2x text-secondary"></i>
                          <i class="fas fa-list-ul fa-stack-1x fa-inverse"></i>
                        </span>
                        <h5><strong class="ml-1 text-dark">Untracked Policy</strong></h5>
                      </label>
                      <div v-if="claim.untrackedPolicy">
                        <div class="card bg-card-xlight mb-2">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-12 mb-2">
                                <h6 class="label text-dark mb-0">{{claim.untrackedPolicy.policyNumber}}</h6>
                                <h5>{{claim.untrackedPolicy.carrierName}}</h5>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Policy Number</strong></label>
                                <span></span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Adjuster Name</strong></label>
                                <span>{{claim.untrackedPolicy.adjusterName}}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Adjuster Email</strong></label>
                                <span>{{claim.untrackedPolicy.adjusterEmail}}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Contact #</strong></label>
                                <span>{{claim.untrackedPolicy.adjusterPhoneNumber}}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Deductible Paid</strong></label>
                                <span>{{claim.untrackedPolicy.deductiblePaid | formatCurrency}}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label"><strong>Amount Received</strong></label>
                                <span>{{claim.untrackedPolicy.amountReceived | formatCurrency}}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label m-0"><strong>Reason</strong></label>
                                <span>{{ claim.reason }}</span>
                              </div>
                              <div class="col-4 mb-2">
                                <label class="label m-0"><strong>Determined Cause</strong></label>
                                <span>{{ claim.determinedCause }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <label class="xsection-label d-flex mb-3">
                    <span class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x text-secondary"></i>
                      <i class="fas fa-dollar-sign fa-stack-1x fa-inverse"></i>
                    </span>
                    <h5><strong class="ml-1 text-dark mb-0">Costs</strong></h5>
                  </label>
                  <div class="w-100 row">

                    <!-- SECTION 1: INCURRED LOSS -->
                    <div class="col-12">
                      <div class="row">
                        <div v-for="(expense, index) in claim.claimCosts" :key="index" class="mb-1 col-4">
                          <label class="label m-0 mr-4">{{ expense.categoryString }}</label>
                          <h5>{{ expense.amount | formatCurrency }}</h5>
                        </div>
                      </div>
                    </div>

                    <!-- SECTION 2: COVERAGE EXCLUSIONS -->
                    <div class="mb-3 col-12">
                      <div class="row">
                        <div class="mb-2 col-4">
                          <label class="label m-0 mr-4">Uninsured / Excluded Expenses</label>
                          <h5 class="text-danger">({{ claim.coverageExclusionsTotal | formatCurrency }})</h5>
                        </div>
                        <div class="mb-2 col-4">
                          <label class="label m-0 mr-4">Deductible Paid</label>
                          <h5 class="text-danger">({{ claim.totalDeductiblePaid | formatCurrency }})</h5>
                        </div>
                        <div class="mb-2 col-4">
                          <label class="label m-0 mr-4">Net Loss Recoverable from Insurance</label>
                          <h5 class="text-success">{{ claim.netLossRecoverableFromInsurance | formatCurrency }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4 border-top pt-4">
                    <div class="d-flex align-items-center mb-1">
                      <label class="section-label mr-1">
                        <span class="fa-stack visibility-none">
                          <i class="fas fa-circle fa-stack-2x text-muted"></i>
                          <i class="fa fa-info fa-stack-1x fa-inverse"></i>
                        </span>
                      </label>
                      <h5 class="text-dark mb-0"><strong>Determined Cause</strong></h5>
                    </div>
                    <div class="mt-3">
                      <div>
                        <span>{{ claim.determinedCause }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="claim.notes" class="border-top pt-4 pb-3">
                    <div class="d-flex align-items-center mb-1">
                      <label class="section-label mr-1">
                        <span class="fa-stack visibility-none">
                          <i class="fas fa-circle fa-stack-2x text-muted"></i>
                          <i class="fa fa-sticky-note-o fa-stack-1x fa-inverse"></i>
                        </span>
                      </label>
                      <h5 class="text-dark mb-0"><strong>Notes</strong></h5>
                    </div>
                    <div>
                      <div>{{ claim.notes }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Activity" class="pb-3 px-3 px-md-5 px-lg-5 px-xl-3" @click="loadActivityLog">
          <template #title>
            <i class="fas fa-history d-md-none d-inline p-md-0 px-2"></i><span
              class="d-md-inline d-none">Activity</span>
          </template>
          <div class="d-flex justify-content-between my-3">
            <h5 class="mb-2">Event Activity Log</h5>
          </div>
          <b-table-simple bordered class="table rg-table">
            <b-thead>
              <b-tr>
                <b-th>Time</b-th>
                <b-th>Item</b-th>
                <b-th>Action</b-th>
                <b-th>Description</b-th>
                <b-th>Person</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-if="activityLog">
              <b-tr v-for="logEntry in activityLog.activityLogs" v-bind:key="logEntry.id">
                <b-td class="text-nowrap">{{logEntry.dateOccurredLocal | formatDate}}</b-td>
                <b-td>{{logEntry.activityElement}}</b-td>
                <b-td>{{logEntry.activity}}</b-td>
                <b-td>{{logEntry.description}}</b-td>
                <b-td>{{logEntry.person}}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-tab>
      </b-tabs>
      
             <!-- Image Upload Modal using FileUploadModal component -->
       <FileUploadModal
         v-model="imageUploadModalOpen"
         file-type="image"
         :accepted-file-types="acceptedImageTypes"
         :processing="processing"
         :event-id="eventId"
         :multiple="multiple"
         modal-title="Upload Event Images"
         upload-title="Upload New Event Images"
         name-placeholder="Image Name"
         description-placeholder="Image Description"
         save-button-text="Upload Images"
         @upload="handleImageUpload"
         @modal-hidden="onImageModalHidden"
       />
      
       <b-modal id="image-detail" ref="image-detail" hide-footer>
        <b-img :src="this.fullImage.publicUrl" class="card-img" />
      </b-modal>
      <b-modal id="incidentReport" modal-class="modal-drawer" size="lg" hide-footer hide-header
        v-model="incidentReportVisible" no-close-on-backdrop body-class="p-0 d-flex flex-column">
        <IncidentReportWizard
          v-if="incidentReportVisible && eventToManageForDisplay"
          :event="eventToManageForDisplay"
          @close="incidentReportVisible = false"
          @reportGenerated="onIncidentReportGenerated"
          @goToFiles="onGoToFilesFromReport"
        />
      </b-modal>
      <b-modal id="event-delete" ref="event-delete" title="Are you sure you want to delete this event?" hide-footer>
        <div class="text-center p-3">
          <h5 class="mb-1"><strong>Delete Event</strong></h5>
          <h5 class="mb-5"><span>{{ eventToManageForDisplay.number}}</span></h5>
          <ValidationObserver v-slot="{ invalid }" ref="imageFormValidationObserver">
            <b-form>
              <p class="mb-1">Enter the "event number" to verify the event being deleted</p>
              <div class="form-group w-75 mx-auto">
                <ValidationProvider name="EventId" :rules="{required: true, is: eventToManage.number}"
                  v-slot="validation">
                  <b-form-input placeholder="Type/paste event number here" size="lg" v-model="deleteEventNumber"
                    :state="spr2_getValidationState(validation)" aria-describedby="event-id-validate-feedback" />
                  <b-form-invalid-feedback id="event-id-validate-feedback">You must type/paste the exact event number to
                    delete it.</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
              <b-button variant="danger" @click="doDeleteEvent(eventToManage.id)" :disabled="invalid">Confirm
                Delete</b-button>
            </b-form>
          </ValidationObserver>
        </div>
      </b-modal>
      <b-modal id="add-edit-expense" ref="add-edit-expense" modal-class="modal-drawer" size="lg" class="modal-drawer" no-close-on-backdrop scrollable hide-footer>
        <template #modal-header>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <h5>{{ expenseForEdit.id ? 'Edit' : 'Add' }} Expense</h5>
            <div>
              <b-button variant="primary" @click="onSaveExpense" :disabled="expenseFormInvalid">Save</b-button>
              <b-button variant="secondary" class="ml-1" @click="onCloseExpenseModal">Close</b-button>
            </div>
          </div>
        </template>
        <ValidationObserver v-slot="{  }" ref="expenseFormValidationObserver">
          <div class="p-3 d-flex flex-column gap-2">
          <h5 class="mb-2">Cost Details</h5>
          <div class="row">
            <div class="col-md-4 col-12 mb-2">
              <label class="control-label">Type</label>
              <b-form-group class="m-0">
                <ValidationProvider name="ExpenseSource" rules="required" v-slot="validation" immediate>
                  <b-form-select :options="expenseSourceTypes" v-model="expenseForEdit.expenseSource"
                    :state="spr2_getValidationState(validation)">
                    <template #first>
                      <b-form-select-option :value="null" disabled :state="Boolean(false)">Select a
                        Type</b-form-select-option>
                    </template>
                  </b-form-select>
                </ValidationProvider>
              </b-form-group>
            </div>
            <div class="col-md-8 col-12 mb-2">
              <label class="control-label">{{ expenseForEdit.expenseSource == 0 ? 'Vendor Name' : 'Other' }}</label>
              <div v-if="expenseForEdit.expenseSource == 0">
                <b-form-group class="m-0">
                  <ValidationProvider name="Vendor" rules="required" v-slot="validation" immediate>
                    <b-form-select :options="propertyVendors" v-model="expenseForEdit.vendorId"
                      :state="spr2_getValidationState(validation)">
                      <template #first>
                        <b-form-select-option :value="null" disabled>Select a Vendor</b-form-select-option>
                      </template>
                    </b-form-select>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div v-else-if="expenseForEdit.expenseSource == 1">
                <b-form-group class="m-0">
                  <ValidationProvider name="Vendor" rules="required" v-slot="validation" immediate>
                    <b-form-input placeholder="Type Name" v-model="expenseForEdit.otherName"
                      :state="spr2_getValidationState(validation)"></b-form-input>
                  </ValidationProvider>
                </b-form-group>
              </div>
              <div v-else class="form-control">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-2">
              <label class="control-label">Details</label>
              <b-form-group class="m-0"> 
                <b-form-textarea placeholder="Expense Details" v-model="expenseForEdit.detail"></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12 mb-2">
              <label class="control-label">Cost Category</label>
              <b-form-group class="m-0">
                <ValidationProvider name="CostCategory" rules="required" v-slot="validation" immediate>
                  <b-form-select :options="costCategoryTypes" v-model="expenseForEdit.costCategory"
                    :state="spr2_getValidationState(validation)">
                    <template #first>
                      <b-form-select-option :value="null" disabled :state="Boolean(false)">Select a
                        Type</b-form-select-option>
                    </template>
                  </b-form-select>
                </ValidationProvider>
              </b-form-group>
            </div>
            <div class="col-md-6 col-12 mb-2">
                <b-form-group class="m-0">
                 <label class="control-label">Amount</label>
                  <b-form-input type="text" placeholder="$0" v-model="expenseForEdit.amount"
                    v-currency-input :state="isAmountValid(expenseForEdit.amount)"></b-form-input>
                </b-form-group>
            </div>
          </div>
          <h5 class="mb-2 mt-4">Payment Details</h5>
          <div class="row">
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Invoice Date</label>
                  <b-form-input type="date" class="form-control" v-model="expenseForEdit.invoiceDate"/>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Invoice Number</label>
                  <b-form-input type="text" placeholder="#" v-model="expenseForEdit.invoiceNumber"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">GL Code</label>
                  <b-form-input type="text" placeholder="GL Code" v-model="expenseForEdit.gl"></b-form-input>
                </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Invoice Amount</label>
                  <b-form-input type="text" placeholder="$0" v-model="expenseForEdit.invoiceAmount"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Invoice Adjustment</label>
                  <b-form-input type="text" placeholder="$0" v-model="expenseForEdit.invoiceAdjustment"
                    v-currency-input></b-form-input>
                </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Date Paid</label>
                  <b-form-input type="date" v-model="expenseForEdit.datePaid" />
                </b-form-group>
            </div>
            <div class="col-md-4 col-12 mb-2">
                <b-form-group class="m-0">
                  <label class="control-label">Check Number</label>
                  <b-form-input type="text" placeholder="Check #" v-model="expenseForEdit.checkNumber"></b-form-input>
                </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-2">
              <b-form-group class="m-0"> 
                <label class="control-label">Details</label>
                <b-form-textarea placeholder="Expense Details" v-model="expenseForEdit.paymentDetails"></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <!-- <h5 class="mb-2 mt-4">Invoice</h5>
          <div class="row">
            <div class="col-md-8 col-12 mb-2">
              <label class="control-label">Attach Invoice</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <button class="btn btn-light border" type="button" id="button-addon1">Choose File</button>
                </div>
                <input type="text" class="form-control" placeholder="Select File" aria-label="Example text with button addon" aria-describedby="button-addon1">
              </div>
            </div>
          </div> -->
          </div>
        </ValidationObserver>
      </b-modal>

      <!-- QR Code modal -->
      <QRCodeModal
        v-if="canViewQRCode"
        :visible.sync="qrCodeModalVisible"
        :qr-code-url="activeQRCodeFile && activeQRCodeFile.qrCodePublicUrl"
        :qr-code-svg-url="activeQRCodeFile && activeQRCodeFile.qrCodeSvgPublicUrl"
        :public-share-url="activeQRCodeFile && activeQRCodeFile.publicShareUrl"
        :file-name="activeQRCodeFile && activeQRCodeFile.name"
        :file-type="activeQRCodeFile && activeQRCodeFile.fileType" />

      <!-- Share Files modal -->
      <b-modal v-model="fileShareModalVisible" title="Share Files" ok-only ok-title="Done" size="lg" @hidden="onShareModalHidden">

        <!-- ══ STEP 1: File / folder selection ══ -->
        <template v-if="shareModalStep === 'select'">
          <p class="mb-2 text-muted small">Choose which files to include in the share link. Unchecking a folder excludes all its files.</p>

          <!-- Loading spinner -->
          <div v-if="shareFileTreeLoading" class="text-center py-4">
            <b-spinner small></b-spinner> Loading files…
          </div>

          <template v-else-if="shareFileTree">
            <!-- Select-all header -->
            <div class="d-flex align-items-center mb-2 border-bottom pb-2">
              <b-form-checkbox
                :checked="shareAllSelected"
                :indeterminate="shareSelectedCount > 0 && !shareAllSelected"
                @change="toggleSelectAll"
                class="mb-0 font-weight-bold">
                {{ shareAllSelected ? 'Deselect All' : 'Select All' }}
              </b-form-checkbox>
              <span class="ml-auto small text-muted">
                {{ shareSelectedCount }} of {{ shareTotalFileCount }} file{{ shareTotalFileCount !== 1 ? 's' : '' }} selected
              </span>
            </div>

            <!-- Folders -->
            <div v-if="shareFileTree.folders && shareFileTree.folders.length" class="mb-2">
              <div v-for="folder in shareFileTree.folders" :key="folder.id" class="mb-1">
                <!-- Folder row -->
                <div class="d-flex align-items-center">
                  <b-button variant="link" size="sm" class="p-0 mr-1 text-muted" @click="toggleFolderExpand(folder.id)" style="line-height:1; width:18px;">
                    <i :class="shareExpandedFolders.includes(folder.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" style="font-size:10px;"></i>
                  </b-button>
                  <b-form-checkbox
                    :checked="isFolderChecked(folder.id)"
                    :indeterminate="isFolderIndeterminate(folder.id)"
                    @change="val => toggleFolder(folder.id, val)"
                    class="mb-0">
                    <i class="fas fa-folder mr-1 text-secondary"></i>
                    <strong>{{ folder.name }}</strong>
                    <span class="text-muted small ml-1">({{ folder.childCount || 0 }})</span>
                  </b-form-checkbox>
                </div>
                <!-- Folder contents (lazy-loaded) -->
                <div v-if="shareExpandedFolders.includes(folder.id)" class="ml-4 mt-1">
                  <div v-if="!shareFolderCache[folder.id]" class="text-muted small py-1">
                    <b-spinner small></b-spinner> Loading…
                  </div>
                  <template v-else>
                    <div v-if="!getFolderFiles(folder.id).length" class="text-muted small py-1">No files</div>
                    <div v-for="file in getFolderFiles(folder.id)" :key="file.id" class="mb-1">
                      <b-form-checkbox
                        :checked="shareSelectedFileIds.has(file.id)"
                        @change="val => toggleFile(file.id, val, folder.id)"
                        class="mb-0">
                        <i :class="getFileIcon(file)" class="mr-1" style="width:14px;"></i>
                        {{ file.name || file.fileName }}
                      </b-form-checkbox>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Root-level files (not in any folder) -->
            <div v-if="shareTreeAllRootFiles.length">
              <div v-for="file in shareTreeAllRootFiles" :key="file.id" class="mb-1">
                <b-form-checkbox
                  :checked="shareSelectedFileIds.has(file.id)"
                  @change="val => toggleFile(file.id, val, null)"
                  class="mb-0">
                  <i :class="getFileIcon(file)" class="mr-1" style="width:14px;"></i>
                  {{ file.name || file.fileName }}
                </b-form-checkbox>
              </div>
            </div>

            <div v-if="!shareFileTree.folders.length && !shareTreeAllRootFiles.length" class="text-muted small py-2">
              No files found for this event.
            </div>
          </template>

          <div v-else class="text-muted small py-2">Unable to load files.</div>

          <!-- Step footer -->
          <div class="d-flex justify-content-end mt-3 pt-2 border-top" style="gap:8px;">
            <b-button variant="secondary" @click="fileShareModalVisible = false">Cancel</b-button>
            <b-button variant="primary" :disabled="shareSelectedCount === 0" @click="shareModalStep = 'expiry'">
              Next: Set Expiration <i class="fas fa-arrow-right ml-1"></i>
            </b-button>
          </div>
        </template>

        <!-- ══ STEP 2: Expiration picker / share result ══ -->
        <template v-if="shareModalStep === 'expiry'">
          <!-- Selection summary badge -->
          <div class="mb-3 small text-muted">
            <i class="fas fa-check-circle text-success mr-1"></i>
            <template v-if="shareSelectedCount > 0">
              <strong>{{ shareSelectedCount }}</strong> file{{ shareSelectedCount !== 1 ? 's' : '' }} selected
            </template>
            <template v-else>
              <strong>All files</strong> selected
            </template>
            <b-button variant="link" size="sm" class="p-0 ml-2" @click="goToSelectStep">
              <i class="fas fa-edit"></i> Change selection
            </b-button>
          </div>

          <p class="mb-3">Anyone with this link can view and download the selected files without logging in.</p>

          <!-- ── Reselecting: update file IDs + expiry on existing share ── -->
          <template v-if="shareIsReselecting">
            <b-form-group label="Link expiration" label-size="sm" class="mb-3">
              <b-form-select v-model="shareExpirationDays" size="sm" :options="shareExpirationOptions" />
            </b-form-group>
            <div class="text-right">
              <b-button variant="secondary" class="mr-2" @click="goToSelectStep">
                <i class="fas fa-arrow-left mr-1"></i> Back
              </b-button>
              <b-button variant="primary" :disabled="shareActionLoading" @click="applyFileSelectionUpdate">
                <b-spinner v-if="shareActionLoading" small class="mr-1"></b-spinner>Save Changes
              </b-button>
            </div>
          </template>

          <!-- ── Pre-creation: no link generated yet ── -->
          <template v-else-if="!existingShareUrl">
            <b-form-group label="Link expiration" label-size="sm" class="mb-3">
              <b-form-select v-model="shareExpirationDays" size="sm" :options="shareExpirationOptions" />
            </b-form-group>
            <div class="text-right">
              <b-button variant="secondary" class="mr-2" @click="goToSelectStep">
                <i class="fas fa-arrow-left mr-1"></i> Back
              </b-button>
              <b-button variant="primary" :disabled="shareActionLoading" @click="doCreateShareLink">
                <b-spinner v-if="shareActionLoading" small class="mr-1"></b-spinner>Generate Share Link
              </b-button>
            </div>
          </template>

          <!-- ── Share created ── -->
          <template v-else>
            <!-- Expiration badge -->
            <div class="mb-2 small">
              <span v-if="existingShareExpiresDateUtc" class="text-muted">
                <i class="fas fa-clock mr-1"></i>Expires {{ formatShareExpiration(existingShareExpiresDateUtc) }}
              </span>
              <span v-else class="text-muted"><i class="fas fa-infinity mr-1"></i>No expiration (permanent link)</span>
            </div>

            <!-- Scoped file badge -->
            <div v-if="existingShareFileIds && existingShareFileIds.length" class="mb-2 small text-muted">
              <i class="fas fa-filter mr-1"></i>Share includes {{ existingShareFileIds.length }} specific file{{ existingShareFileIds.length !== 1 ? 's' : '' }}
            </div>

            <!-- Link + copy -->
            <div class="input-group mb-3">
              <input type="text" class="form-control" :value="existingShareUrl" readonly ref="shareUrlInput" />
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" @click="copyFileShareUrl">{{ shareCopyLabel }}</button>
              </div>
            </div>

            <!-- QR code -->
            <div v-if="canViewQRCode && existingShareQrCodeUrl" class="text-center mb-3">
              <img :src="existingShareQrCodeUrl" class="img-fluid" style="max-width:180px;" alt="QR Code for shared files" />
              <p class="small text-muted mt-1">Scan to access shared files on any device</p>
            </div>

            <!-- Revoke confirmation -->
            <div v-if="shareRevokeConfirming" class="alert alert-warning py-2 px-3 mb-2">
              <strong>Deactivate this link?</strong> Anyone with the current link will immediately lose access.
              <div class="mt-2 d-flex" style="gap:8px;">
                <b-button size="sm" variant="danger" :disabled="shareActionLoading" @click="confirmRevokeShare">
                  <b-spinner v-if="shareActionLoading" small class="mr-1"></b-spinner>Yes, deactivate
                </b-button>
                <b-button size="sm" variant="outline-secondary" @click="shareRevokeConfirming = false">Cancel</b-button>
              </div>
            </div>

            <!-- Action row -->
            <div v-if="!shareRevokeConfirming" class="d-flex justify-content-between align-items-center mt-1">
              <b-button size="sm" variant="outline-danger" @click="shareRevokeConfirming = true">Deactivate Link</b-button>
              <b-button size="sm" variant="outline-secondary" :disabled="shareActionLoading" @click="createNewShareLink">
                <b-spinner v-if="shareActionLoading" small class="mr-1"></b-spinner>Create New Link
              </b-button>
            </div>
          </template>
        </template>

      </b-modal>

      <!-- SOP Video Player -->
      <VideoPlayerModal
        :visible.sync="sopVideoPlayerVisible"
        :videos="sopVideoPlaylist"
        :start-index="sopVideoIndex" />

    </div>
    <div v-if="!userPermissions.manageEvents || !canViewEvent" class="d-flex justify-content-center p-4">
      <div class="p-4 m-5 alert alert-danger">
        <h2><i class="fas fa-exclamation-triangle" aria-hidden="true"></i> You are not authorized to view this page</h2>
      </div>
    </div>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="p-5" style="width: 200px; height: 200px;">
      <b-spinner small label="Small Spinner"></b-spinner> Loading event...
    </div>
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import { Datetime } from 'vue-datetime'
import EventPeople from '@/views/event/EventPeople'
import IncidentReportWizard from '@/views/event/IncidentReportWizard'
import EventCorrespondenceTab from '@/views/event/EventCorrespondenceTab'
import { eventManageTabIndex } from '@/utils/eventCorrespondenceFilters'
import { spr2Procedures, spr2Validation } from '../mixins/Spr2SharedFunctions'
import Resources from '../views/Resources.vue'

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import FileUploadModal from '@/components/FileUploadModal.vue'
import FileThumbnail from '@/components/FileThumbnail.vue'
import QRCodeModal from '@/components/QRCodeModal.vue'
import VideoPlayerModal from '@/components/VideoPlayerModal.vue'
import publicFilesApi from '@/api/publicFilesApi'

// import router from '../router'
export default {
  name: 'StatusDropdown',
  mixins: [ spr2Procedures, spr2Validation ],
  components: {
    resources: Resources,
    datetime: Datetime,
    eventPeople: EventPeople,
    IncidentReportWizard,
    EventCorrespondenceTab,
    VueGallerySlideshow,
    FileUploadModal,
    FileThumbnail,
    QRCodeModal,
    VideoPlayerModal
  },
  data () {
    return {
      modalOpen: false,
      tabIndex: 0,
      generatingIncident: false,
      documentForUpload2: { name: null, file: null, documentTypeId: '' },
      // fileForUpload: null,
      eventChangeDetails: { status: 0, summary: '', location: '', visibleToPositionTypeId: [] },
      activityLog: null,

      fullImage: {},
      incidentReportVisible: false,
      documentUploadInProgress: false,
      deleteEventNumber: null,
      folderId: null,
      property: null,
      processing: false,
      loading: true,
      index: null,
      questionIndex: null,
      allPositionTypesList: [],
      visibleToRolesExpanded: false,
      canViewEvent: false,
      damageRelatedExpenses: [],
      acceptedImageTypes: [],
      imageUploadModalOpen: false,
      multiple: true,
      //Expenses
      propertyVendors: [],
      expenseForEdit: {},
      expenseSourceTypes: [
        {
          text: 'Vendor',
          value: 0
        },
        {
          text: 'Other',
          value: 1
        }
      ],
      costCategoryTypes: [
      {
          text: 'Mitigation',
          value: 'Mitigation'
        },
        {
          text: 'Repair',
          value: 'Repair'
        },
        {
          text: 'Business Interruption',
          value: 'BusinessInterruption'
        },
        {
          text: 'Uninsured Expense',
          value: 'UninsuredExpense'
        },
        {
          text: 'Other',
          value: 'Other'
        }
      ],
      // QR Code modal
      qrCodeModalVisible: false,
      activeQRCodeFile: null,
      // Share Files feature
      fileShareModalVisible: false,
      existingShareId: null,
      existingShareUrl: null,
      existingShareQrCodeUrl: null,
      existingShareQrCodeSvgUrl: null,
      existingShareExpiresDateUtc: null,
      existingShareFileIds: [],
      shareCopyLabel: 'Copy Link',
      shareRevokeConfirming: false,
      shareActionLoading: false,
      shareExpirationDays: 'permanent',
      shareIsReselecting: false,  // true when editing file selection on an existing share
      // Share modal step: 'select' (pick files) or 'expiry' (set expiration / show result)
      shareModalStep: 'select',
      // File-tree for the share picker
      shareFileTree: null,         // raw GetFileResourcesResponse from API
      shareFileTreeLoading: false,
      // Expanded folder IDs in the picker
      shareExpandedFolders: [],
      // Folder contents cache: folderId → GetFileResourcesResponse
      shareFolderCache: {},
      // Checked item set: Set of fileId strings
      shareSelectedFileIds: new Set(),
      // Indeterminate folder IDs (some but not all children checked)
      shareIndeterminateFolderIds: new Set(),
      // SOP Question Media
      sopQuestionVideos: [],
      sopVideoPlayerVisible: false,
      sopVideoIndex: 0,
      sopImageIndex: null,
      sopMediaLoading: false
    }
  },
  computed: {
    qrCodeFeatureEnabled () {
      return this.$store.getters['featureFlags/isEnabled']('media.qrcode-sharing')
    },
    canViewQRCode () {
      return this.qrCodeFeatureEnabled &&
             (this.$store.state.loggedInUserPermissions && this.$store.state.loggedInUserPermissions.viewQRCode === true)
    },
    shareExpirationOptions () {
      const opts = [
        { value: 'permanent', text: 'No expiration (permanent)' },
        { value: 1,  text: 'Expires in 24 hours' },
        { value: 7,  text: 'Expires in 7 days' },
        { value: 30, text: 'Expires in 30 days' },
        { value: 90, text: 'Expires in 90 days' }
      ]
      // When editing an existing share that already has an expiry, prepend a "Keep current" option
      if (this.shareIsReselecting && this.existingShareExpiresDateUtc) {
        opts.unshift({ value: 'keep', text: `Keep current (${this.formatShareExpiration(this.existingShareExpiresDateUtc)})` })
      }
      return opts
    },
    // All files in the root share tree (flat list, excludes folder contents not yet loaded)
    shareTreeAllRootFiles () {
      if (!this.shareFileTree) return []
      const all = []
      ;(this.shareFileTree.documents || []).forEach(f => { if (!f.folderId) all.push(f) })
      ;(this.shareFileTree.images || []).forEach(f => { if (!f.folderId) all.push(f) })
      ;(this.shareFileTree.videos || []).forEach(f => { if (!f.folderId) all.push(f) })
      return all
    },
    shareTotalFileCount () {
      if (!this.shareFileTree) return 0
      let count = this.shareTreeAllRootFiles.length
      // Add files from loaded folder caches
      Object.values(this.shareFolderCache).forEach(fc => {
        (fc.documents || []).forEach(() => count++)
        ;(fc.images || []).forEach(() => count++)
        ;(fc.videos || []).forEach(() => count++)
      })
      return count
    },
    shareSelectedCount () {
      return this.shareSelectedFileIds.size
    },
    shareAllSelected () {
      if (this.shareTotalFileCount === 0) return false
      return this.shareSelectedCount === this.shareTotalFileCount
    },
    imagesForGallery () {
      return this.imagesForEvent.map((image) => {
        return {
          url: image.publicUrl,
          id: image.id,
          alt: (image.notes || image.name)
        }
      })
    },
    imagesForQuestions () {
      let images = []
      this.eventToManageForDisplay.sopQuestions.map((question) => {
        question.images.forEach((image) => {
          images.push({id: image.id, url: image.publicUrl, alt: image.name})
        })
      })
      return images
    },
    sopQuestionImages () {
      // Flatten all images across all SOP questions
      const images = []
      ;(this.eventToManageForDisplay.sopQuestions || []).forEach(q => {
        ;(q.images || []).forEach(img => images.push(img))
      })
      return images
    },
    sopImageGallery () {
      return this.sopQuestionImages.map(img => ({ url: img.publicUrl, alt: img.name || img.fileName }))
    },
    sopVideoPlaylist () {
      return this.sopQuestionVideos.map(v => ({
        url: v.videoProcessingStatus === 'Complete' && v.processedVideoPublicUrl ? v.processedVideoPublicUrl : v.publicUrl,
        contentType: 'video/mp4',
        name: v.name || v.fileName,
        thumbnailUrl: v.thumbnailPublicUrl
      }))
    },
    eventDetailsChanged () {
      var changeLength = this.eventChangeDetails && this.eventChangeDetails.visibleToPositionTypeIds ? this.eventChangeDetails.visibleToPositionTypeIds.length : 0
      return (
        this.eventToManage.status !== this.eventChangeDetails.status ||
        this.eventToManage.summary !== this.eventChangeDetails.summary ||
        this.eventToManage.location !== this.eventChangeDetails.location ||
        this.eventToManage.visibleToPositionTypes.length !== changeLength
      )
    },
    eventStatuses () {
      var statusArray =
      [
        {
          text: 'New',
          value: 0
        },
        {
          text: 'In Progress',
          value: 1
        },
        {
          text: 'Pending Approval',
          value: 2
        },
        {
          text: 'Approved',
          value: 3
        },
        {
          text: 'SOP In Progress',
          value: 5
        },
        {
          text: 'Claim in Progress',
          value: 8
        }
      ]
      if (this.userPermissions.completeEvents) {
        statusArray.push({
          text: 'Complete',
          value: 4
        })
      }
      if (this.eventToManage && this.eventToManage.isSopComplete && this.eventToManage.status !== 5) {
        statusArray = statusArray.filter(s => s.value !== 5)
      }
      // Hide New option once status has moved past New and a management report exists
      if (this.eventToManage && this.eventToManage.status !== 0 && this.eventChangeDetails.summary && this.eventChangeDetails.summary.trim().length > 0) {
        statusArray = statusArray.filter(s => s.value !== 0)
      }
      return statusArray
    },
    eventToManage () {
      return this.$store.state.events.eventToManage
    },
    claimForEdit () {
      return this.$store.state.events.claimForEdit
    },
    eventToManageForDisplay () {
      return this.$store.state.events.eventToManageForDisplay
    },
    eventId () {
      return this.$route.params.id
    },
    tab () {
      return this.$route.params.tab
    },
    imagesForEvent () {
      return this.eventToManageForDisplay.images
    },
    documentTypesOptions () {
      var project = (o, p) => {
        return { text: o.name, value: o.id }
      }
      var types = this.$store.state.events.documentTypes
      var results = []

      for (var i = 0; i < types.length; i++) {
        var obj = types[i]
        var projection = { text: 1, value: 1 }
        var projectedObj = project(obj, projection)
        console.log(projectedObj)
        results.push(projectedObj)
      }
      console.log(
        'Returning Document Types Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    },
    claims () {
      return this.$store.state.events.claims
    },
    userPermissions () {
      return this.$store.state.loggedInUserPermissions
    },
    allPositionTypesListOptions () {
      var activeTypes = this.allPositionTypesList.filter(item => item.active === true)
      var results = activeTypes.map((val, index) => {
        return { text: val.name, value: val.id }
      })
      console.log(
        'Returning Position Types Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    },
    visibleToRolesCount () {
      var count = this.eventChangeDetails && this.eventChangeDetails.visibleToPositionTypeIds ? this.eventChangeDetails.visibleToPositionTypeIds.length : 0
      return count
    },
    totalExpenses () {
      let totalVal = this.damageRelatedExpenses.reduce((acc, curr) => acc + this.cleanseData(curr.amount), 0)
      return totalVal
    },
    expenseFormInvalid () {
      // Check if required fields are valid
      const hasExpenseSource = this.expenseForEdit.expenseSource !== null && this.expenseForEdit.expenseSource !== undefined
      const hasValidAmount = this.expenseForEdit.amount && this.cleanseData(this.expenseForEdit.amount) > 0
      const hasValidCostCategory = this.expenseForEdit.costCategory !== null && this.expenseForEdit.costCategory !== undefined
      
      // For vendor type, check if vendor is selected
      let hasValidVendorInfo = true
      if (this.expenseForEdit.expenseSource === 0) {
        hasValidVendorInfo = this.expenseForEdit.vendorId !== null && this.expenseForEdit.vendorId !== undefined
      } else if (this.expenseForEdit.expenseSource === 1) {
        hasValidVendorInfo = this.expenseForEdit.otherName && this.expenseForEdit.otherName.trim().length > 0
      }
      
      return !(hasExpenseSource && hasValidAmount && hasValidCostCategory && hasValidVendorInfo)
    },
  },
  async created () {
    this.loading = true
    this.canViewEvent = await this.canUserViewEvent(this.eventId)
    if (this.canViewEvent) {
      await this.doLoadEventToManage(this.eventId)
      this.initializeChangeDetails()
      await this.doLoadEventToManageForDisplay(this.eventId)
      await this.loadExistingShare()
      this.loadSopQuestionVideos()
      await this.loadDocumentTypes()
      await this.initDocumentForUpload()
      await this.doLoadPositionTypes()
      await this.doLoadPropertyVendors()
      this.getAcceptedFileTypes().then((types) => {
        this.acceptedImageTypes = types.filter((item) => { return item.type === 2 })
      })
      if (this.tab === 'claims' && this.tabIndexFor('claim') !== -1) {
        this.tabIndex = this.tabIndexFor('claim')
      }
      if (this.tab === 'damages') {
        this.tabIndex = this.tabIndexFor('expenses')
      }
      if (this.tab === 'correspondence' && this.tabIndexFor('correspondence') !== -1) {
        this.tabIndex = this.tabIndexFor('correspondence')
      }
    }
    this.loading = false
  },
  methods: {
    // Index of a tab among the rendered b-tabs, accounting for permission-conditional tabs.
    tabIndexFor (key) {
      return eventManageTabIndex(key, this.userPermissions)
    },
    formatShareExpiration (dateStr) {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    },
    async doLoadPropertyVendors () {
      var response = await this.getPropertyVendors(this.eventToManage.propertyId)
      this.propertyVendors = response.data.vendors.map((v) => {
        return {text: v.name, value: v.id}
      })
    },
    async initDocumentForUpload () {
      this.documentForUpload2 = {
        name: '',
        file: null,
        eventId: this.eventId
      }
    },

    doShowFullImage (image) {
      this.fullImage = image
      this.$refs['image-detail'].show()
    },
    toggleModal () {
      this.modalOpen = !this.modalOpen
    },
    closeEventManage () {
      this.loadEventToManageForDisplay(null)
      this.$router.push('/events')
    },
    doLoadEventToManage (eventId) {
      return this.loadEventToManage(eventId)
    },
    doDeleteEvent (eventId) {
      this.deleteEvent({selectedEventId: eventId, verifiedEventId: eventId})
        .then(() => {
          this.$refs['event-delete'].hide()
          this.$router.push('/events')
          this.$toasted.show('Event Deleted.', { duration: 4000 })
        })
    },
    async doLoadEventToManageForDisplay (eventId) {
      this.loadEventToManageForDisplay(eventId).then(() => {
        this.doLoadClaims(eventId)
      }).then(() => {
        this.doLoadDamageRelatedExpenses(eventId)
      })
    },
    doDownloadDocument (documentId, fileName) {
      this.downloadDocument({ eventId: this.eventId, documentId, fileName })
    },
    doSaveDetails () {
      // Auto-advance from New to In Progress when a management report has been entered
      if (this.eventChangeDetails.status === 0 && this.eventChangeDetails.summary && this.eventChangeDetails.summary.trim().length > 0) {
        this.eventChangeDetails.status = 1
      }
      this.saveEventDetails({
        eventId: this.eventId,
        details: this.eventChangeDetails
      })
        .then(() => this.initializeChangeDetails())
        .then(() => this.$toasted.show('Event Saved.', { duration: 4000 }))
    },
    initializeChangeDetails () {
      console.log('initializing change details')
      this.eventChangeDetails = {
        status: this.eventToManage.status,
        summary: this.eventToManage.summary,
        location: this.eventToManage.location,
        visibleToPositionTypeIds: this.eventToManage.visibleToPositionTypes.map((val, index) => {
          return val.id
        })
      }
      if (this.eventChangeDetails.visibleToPositionTypeIds.length > 0) {
        this.visibleToRolesExpanded = true
      }
    },
    loadActivityLog () {
      console.log('loading activity log...')
      this.loadEventActivityLog(this.eventId).then(response => {
        this.activityLog = response.data
      })
    },
    async doLoadClaims (eventId) {
      this.loadClaims(eventId).then(() => {
        console.log(
          'Setting insurance claims on event: ' +
          JSON.stringify(this.claims, null, 2)
        )
        this.eventToManageForDisplay.insuranceClaims = this.claims
      })
    },
    async doLoadDamageRelatedExpenses (eventId) {
      this.getDamageRelatedExpenses(eventId).then((result) => {
        this.damageRelatedExpenses = result.data.damageRelatedExpenses
      })
    },
    async doLoadPositionTypes () {
      let pt = await this.getPositionTypes()
      this.allPositionTypesList = pt.data.types
    },
    onIncidentReportGenerated (fileResourceId) {
      this.$toasted && this.$toasted.show('Incident Report is generating — check the Files tab when complete.', { duration: 6000 })
    },
    onGoToFilesFromReport () {
      this.incidentReportVisible = false
      var documentationIndex = this.tabIndexFor('documentation')
      if (this.tabIndex === documentationIndex) {
        this.$refs.resources && this.$refs.resources.loadData()
      } else {
        this.tabIndex = documentationIndex
      }
    },
    async onSaveExpense () {
      // TODO: Implement save logic for expense
      console.log('Save expense clicked', this.expenseForEdit)
      // Validate required fields
      if (!this.expenseForEdit.expenseSource && this.expenseForEdit.expenseSource !== 0) {
        this.$toasted.error('Please select an expense type.', { duration: 3000 })
        return
      }
      if (!this.expenseForEdit.amount || this.expenseForEdit.amount <= 0) {
        this.$toasted.error('Please enter a valid amount.', { duration: 3000 })
        return
      }
     
      // Create a clean expense object for API
      const cleanExpense = {
        id: this.expenseForEdit.id,
        vendorId: this.expenseForEdit.vendorId,
        otherName: this.expenseForEdit.otherName,
        detail: this.expenseForEdit.detail,
        expenseSource: this.expenseForEdit.expenseSource,
        amount: this.cleanseData(this.expenseForEdit.amount),
        costCategory: this.expenseForEdit.costCategory,
        invoiceDate: this.expenseForEdit.invoiceDate,
        invoiceNumber: this.expenseForEdit.invoiceNumber,
        gl: this.expenseForEdit.gl,
        invoiceAmount: this.cleanseData(this.expenseForEdit.invoiceAmount),
        invoiceAdjustment: this.cleanseData(this.expenseForEdit.invoiceAdjustment),
        datePaid: this.expenseForEdit.datePaid,
        checkNumber: this.expenseForEdit.checkNumber,
        paymentDetails: this.expenseForEdit.paymentDetails
      }

      // Handle add vs edit logic for UI array
      if (this.expenseForEdit.index === -1) {
        // Adding new expense - push to end of array
        this.damageRelatedExpenses.push({ ...cleanExpense, index: this.damageRelatedExpenses.length })
      } else {
        // Editing existing expense - replace at specific index
        this.damageRelatedExpenses.splice(this.expenseForEdit.index, 1, { ...cleanExpense, index: this.expenseForEdit.index })
      }

      // Prepare all expenses for API - clean data without UI properties
      let toSave = this.damageRelatedExpenses.map((x) => ({
        id: x.id,
        vendorId: x.vendorId,
        otherName: x.otherName,
        detail: x.detail,
        expenseSource: x.expenseSource,
        amount: typeof x.amount === 'number' ? x.amount : this.cleanseData(x.amount),
        costCategory: x.costCategory,
        invoiceDate: x.invoiceDate,
        invoiceNumber: x.invoiceNumber,
        gl: x.gl,
        invoiceAmount: typeof x.invoiceAmount === 'number' ? x.invoiceAmount : this.cleanseData(x.invoiceAmount),
        invoiceAdjustment: typeof x.invoiceAdjustment === 'number' ? x.invoiceAdjustment : this.cleanseData(x.invoiceAdjustment),
        datePaid: x.datePaid,
        checkNumber: x.checkNumber,
        paymentDetails: x.paymentDetails
      }))
      
      await this.saveDamageRelatedExpenses({eventId: this.eventId, damageRelatedExpenses: toSave})
      this.$router.push({ name: 'EventManage', params: { id: this.eventId, tab: 'damages' } })
      this.$toasted.show('Expenses Saved.', { duration: 3000 })

      let dre = await this.getDamageRelatedExpenses(this.eventId)
      this.damageRelatedExpenses = dre.data.damageRelatedExpenses
      await this.doLoadClaims(this.eventId);
      this.onCloseExpenseModal() // Uncomment when save is implemented
    },
    onCloseExpenseModal () {
      // Reset form data
      this.expenseForEdit = {}
      // Close the modal
      this.$bvModal.hide('add-edit-expense')
    },
    async addExpense () {
      this.expenseForEdit = {
            index: -1,
            id: null,
            vendorId: null,
            //vendorName: this.ve,
            otherName: null,
            detail: null,
            expenseSource: null,
            amount: null,
            costCategory: null,
            invoiceDate: null,
            invoiceNumber: null,
            gl: null,
            invoiceAmount: null,
            invoiceAdjustment: null,
            datePaid: null,
            checkNumber: null,
            paymentDetails: null
        }
        this.$bvModal.show('add-edit-expense')
    },
    editExpense (expense, index) {
      // Load the expense data into the form for editing
      this.expenseForEdit = {
        index: index,
        id: expense.id,
        vendorId: expense.vendorId,
        otherName: expense.otherName,
        detail: expense.detail,
        expenseSource: expense.expenseSource,
        amount: expense.amount ? this.$options.filters.formatCurrency(expense.amount) : '$0.00',
        costCategory: expense.costCategory,
        invoiceDate: expense.invoiceDate,
        invoiceNumber: expense.invoiceNumber,
        gl: expense.gl,
        invoiceAmount: expense.invoiceAmount ? this.$options.filters.formatCurrency(expense.invoiceAmount) : '$0.00',
        invoiceAdjustment: expense.invoiceAdjustment ? this.$options.filters.formatCurrency(expense.invoiceAdjustment) : '$0.00',
        datePaid: expense.datePaid,
        checkNumber: expense.checkNumber,
        paymentDetails: expense.paymentDetails
      }
      
      // Open the modal for editing
      this.$bvModal.show('add-edit-expense')
    },
    async deleteExpense (expense, index) {
      // Show confirmation dialog before deleting
      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to delete this expense: ${expense.expenseSource === 0 ? expense.vendorName : expense.otherName}?`,
        {
          title: 'Confirm Delete',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      ).then(async value => {
        if (value) {
          console.log('Delete expense:', expense)
          // For now, just remove from local array (this would be replaced with API call)
          this.damageRelatedExpenses.splice(index, 1)
          await this.saveDamageRelatedExpenses({eventId: this.eventId, damageRelatedExpenses: this.damageRelatedExpenses})
          await this.doLoadClaims(this.eventId);
          this.$toasted.show('Expense Deleted.', { duration: 3000 })
        }
      })
    },
    ...mapActions('events', [
      'getPropertyVendors',
      'saveDamageRelatedExpenses',
      'getDamageRelatedExpenses',
      'loadEventToManage',
      'loadEventToManageForDisplay',
      'getEventImages',
      'uploadDocument',
      'downloadDocument',
      'loadDocumentTypes',
      'loadClaims',
      'saveClaim',
      'uploadMedias',
      'loadClaimForEdit',
      'createNewClaim', /*  */
      'saveEventDetails',
      'loadEventActivityLog',
      'deleteEvent',
      'canUserViewEvent',
      'getDamageRelatedExpenses',
      'resumeEvent',
      'getEventQuestionMedia'
    ]),
    ...mapActions('company', ['getProperty', 'getPositionTypes']),
    ...mapActions('resources', ['getAcceptedFileTypes']),
    async doResumeSop () {
      await this.resumeEvent(this.eventToManageForDisplay.id)
      this.$router.push({ path: '/eventAdd', query: { resumeSop: 'true' } })
    },
    fileSelectionChanged (file) {
      if (!this.documentForUpload2.name) {
        this.documentForUpload2.name = file.name
      }
    },
    uploadDocumentForEvent () {
      this.documentUploadInProgress = true
      // this.uploadDocument(this.fileList[0])
      this.uploadDocument(this.documentForUpload2)
        .then(() => this.loadEventToManage(this.eventId))
        .then(() => this.loadEventToManageForDisplay(this.eventId))
        .then(() => this.initDocumentForUpload())
        .then(() => { this.documentUploadInProgress = false })
    },
    toggleVisibleToExpanded () {
      this.visibleToRolesExpanded = !this.visibleToRolesExpanded
    },
    cleanseData (data) {
      if (data) {
        let newVal = parseFloat(data.toString().replace('$', '').replace(',', '') || 0)
        return newVal
      } else {
        return 0
      }
    },
    isAmountValid (amount) {
      let amt = this.cleanseData(amount)
      return (!isNaN(amt) && amt > 0)
    },
    handleImageUpload (uploadData) {
       // Convert FileUploadModal data format to the expected format for uploadMedias
       const imageData = {
         type: 'image',
         files: this.multiple ? uploadData.file : [uploadData.file],
         eventId: this.eventId
       }
       
       this.processing = true
       this.uploadMedias(imageData)
         .then((result) => {
           this.getEventImages(this.eventId).then((r) => { 
             this.eventToManageForDisplay.images = r.data.images 
           })
           this.$toasted.success('Images uploaded successfully!', { duration: 4000 })
           // Close the modal after successful upload
           this.imageUploadModalOpen = false
         })
         .catch((error) => {
           this.$toasted.error(error.failureReason || 'Failed to upload images', { duration: 4000 })
         })
         .finally(() => {
           this.processing = false
         })
     },
    onImageModalHidden () {
      this.imageUploadModalOpen = false
    },

    showQRCode (file) {
      this.qrCodeModalVisible = false
      this.$nextTick(() => {
        this.activeQRCodeFile = file
        this.qrCodeModalVisible = true
      })
    },

    async loadSopQuestionVideos () {
      this.sopMediaLoading = true
      try {
        const res = await this.getEventQuestionMedia(this.eventId)
        this.sopQuestionVideos = (res && res.data && res.data.videos) || []
      } catch (e) {
        // Non-critical — SOP media panel stays empty
      } finally {
        this.sopMediaLoading = false
      }
    },
    openSopVideo (index) {
      this.sopVideoIndex = index
      this.sopVideoPlayerVisible = true
    },
    async loadExistingShare () {
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        if (!companyId || !this.eventToManage) return
        const res = await publicFilesApi.getSharesForResource(companyId, this.eventToManage.id)
        const shares = res.data && res.data.shares
        if (shares && shares.length > 0) {
          const latest = shares[0]
          this.existingShareId = latest.shareId
          this.existingShareUrl = latest.publicShareUrl
          this.existingShareExpiresDateUtc = latest.expiresDateUtc || null
          this.existingShareFileIds = latest.fileIds || []
        }
      } catch (e) {
        // Non-critical — silently ignore; user can create one manually
      }
    },

    async createOrShowFileShare () {
      this.shareRevokeConfirming = false

      if (this.existingShareUrl) {
        // Existing share: go straight to the result step so the user can see / manage the link
        this.shareModalStep = 'expiry'
        // Pre-populate selection state from the saved share so the badge shows the right count
        this.shareSelectedFileIds = new Set(this.existingShareFileIds || [])
        this.fileShareModalVisible = true
        return
      }

      // New share: load the file tree, show the selection step
      this.shareModalStep = 'select'
      this.shareExpirationDays = 'permanent'
      this.shareSelectedFileIds = new Set()
      this.shareExpandedFolders = []
      this.shareFolderCache = {}
      this.fileShareModalVisible = true

      await this.loadShareFileTree()
      // Default: select everything
      this.selectAllFiles()
    },

    async goToSelectStep () {
      this.shareModalStep = 'select'
      this.shareIsReselecting = !!this.existingShareUrl
      // Pre-populate expiry: 'keep' if existing share has a set expiry, else 'permanent'
      this.shareExpirationDays = (this.existingShareUrl && this.existingShareExpiresDateUtc) ? 'keep' : 'permanent'
      if (!this.shareFileTree) {
        await this.loadShareFileTree()
        if (this.existingShareFileIds && this.existingShareFileIds.length > 0) {
          this.shareSelectedFileIds = new Set(this.existingShareFileIds)
        } else {
          this.selectAllFiles()
        }
      }
    },

    async loadShareFileTree () {
      this.shareFileTreeLoading = true
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        const res = await publicFilesApi.getEventResources(companyId, this.eventToManage.id)
        this.shareFileTree = res.data
      } catch (e) {
        this.shareFileTree = null
      } finally {
        this.shareFileTreeLoading = false
      }
    },

    selectAllFiles () {
      const ids = new Set()
      if (!this.shareFileTree) return
      this.shareTreeAllRootFiles.forEach(f => ids.add(f.id))
      // Also select files in already-loaded folder caches
      Object.values(this.shareFolderCache).forEach(fc => {
        this.getFolderFilesFromCache(fc).forEach(f => ids.add(f.id))
      })
      this.shareSelectedFileIds = ids
    },

    toggleSelectAll (checked) {
      if (checked) {
        this.selectAllFiles()
      } else {
        this.shareSelectedFileIds = new Set()
      }
    },

    async toggleFolderExpand (folderId) {
      const idx = this.shareExpandedFolders.indexOf(folderId)
      if (idx === -1) {
        this.shareExpandedFolders.push(folderId)
        // Lazy-load folder contents if not yet cached
        if (!this.shareFolderCache[folderId]) {
          await this.loadFolderContents(folderId)
        }
      } else {
        this.shareExpandedFolders.splice(idx, 1)
      }
    },

    async loadFolderContents (folderId) {
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        const res = await publicFilesApi.getEventFolderResources(companyId, this.eventToManage.id, folderId)
        this.$set(this.shareFolderCache, folderId, res.data)
        // Auto-select newly loaded files so default remains "all selected"
        this.getFolderFilesFromCache(res.data).forEach(f => {
          if (!this.shareSelectedFileIds.has(f.id)) {
            const newSet = new Set(this.shareSelectedFileIds)
            newSet.add(f.id)
            this.shareSelectedFileIds = newSet
          }
        })
      } catch (e) {
        // Leave cache entry absent — UI shows error state
      }
    },

    getFolderFilesFromCache (cacheEntry) {
      if (!cacheEntry) return []
      return [
        ...(cacheEntry.documents || []),
        ...(cacheEntry.images || []),
        ...(cacheEntry.videos || [])
      ]
    },

    getFolderFiles (folderId) {
      return this.getFolderFilesFromCache(this.shareFolderCache[folderId])
    },

    isFolderChecked (folderId) {
      if (!this.shareFolderCache[folderId]) return false
      const files = this.getFolderFiles(folderId)
      return files.length > 0 && files.every(f => this.shareSelectedFileIds.has(f.id))
    },

    isFolderIndeterminate (folderId) {
      if (!this.shareFolderCache[folderId]) return false
      const files = this.getFolderFiles(folderId)
      const checkedCount = files.filter(f => this.shareSelectedFileIds.has(f.id)).length
      return checkedCount > 0 && checkedCount < files.length
    },

    toggleFolder (folderId, checked) {
      const files = this.getFolderFiles(folderId)
      const newSet = new Set(this.shareSelectedFileIds)
      files.forEach(f => checked ? newSet.add(f.id) : newSet.delete(f.id))
      this.shareSelectedFileIds = newSet
    },

    toggleFile (fileId, checked, folderId) {
      const newSet = new Set(this.shareSelectedFileIds)
      checked ? newSet.add(fileId) : newSet.delete(fileId)
      this.shareSelectedFileIds = newSet
    },

    getFileIcon (file) {
      if (!file) return 'fas fa-file text-secondary'
      const type = (file.fileType || '').toLowerCase()
      if (type === 'image') return 'fas fa-image text-info'
      if (type === 'video') return 'fas fa-video text-danger'
      return 'fas fa-file text-secondary'
    },

    onShareModalHidden () {
      // Reset the picker state when the modal is fully closed
      this.shareModalStep = 'select'
      this.shareIsReselecting = false
      this.shareFileTree = null
      this.shareExpandedFolders = []
      this.shareFolderCache = {}
      this.shareSelectedFileIds = new Set()
      this.shareRevokeConfirming = false
    },

    async applyFileSelectionUpdate () {
      this.shareActionLoading = true
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        const selectedIds = Array.from(this.shareSelectedFileIds)
        const isAllSelected = selectedIds.length === this.shareTotalFileCount
        const fileIdsPayload = isAllSelected ? [] : selectedIds

        // Resolve expiry: 'keep' = leave as-is, 'permanent' = null, numeric = days from now
        let expiresDateUtc = undefined
        let updateExpiry = false
        if (this.shareExpirationDays === 'keep') {
          // Do not touch the existing expiry
          updateExpiry = false
        } else if (this.shareExpirationDays === 'permanent') {
          expiresDateUtc = null
          updateExpiry = true
        } else {
          expiresDateUtc = new Date(Date.now() + this.shareExpirationDays * 86400000).toISOString()
          updateExpiry = true
        }

        await publicFilesApi.updateShareFileIds(companyId, this.existingShareId, fileIdsPayload, expiresDateUtc, updateExpiry)

        // Persist updated state locally
        this.existingShareFileIds = fileIdsPayload
        if (updateExpiry) this.existingShareExpiresDateUtc = expiresDateUtc || null
        this.shareIsReselecting = false
        this.shareModalStep = 'expiry'
        this.$toasted.success('Share updated.', { duration: 2500 })
      } catch (e) {
        this.$toasted.error('Unable to update share. Please try again.', { duration: 4000 })
      } finally {
        this.shareActionLoading = false
      }
    },

    async doCreateShareLink () {
      this.shareActionLoading = true
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        const companyName = (this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyName) || ''
        const ev = this.eventToManageForDisplay
        const propertyName = ev.property ? ev.property.name : ''
        const incidentNum = ev.number ? `#${ev.number}` : ''
        // Prefer the report date (when the event was logged); fall back to the incident date
        const reportDateRaw = ev.dateReportedLocal || ev.dateOccurredLocal
        const dateStr = reportDateRaw
          ? new Date(reportDateRaw).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
          : ''
        const titleParts = [companyName, propertyName, incidentNum, dateStr].filter(Boolean)
        // Build a description with key event context
        const descParts = []
        if (ev.type) descParts.push(`Type: ${ev.type}`)
        if (ev.category) descParts.push(`Category: ${ev.category}`)
        if (ev.severityLevel) descParts.push(`Severity: ${ev.severityLevel}`)
        if (ev.location) descParts.push(`Location: ${ev.location}`)
        let description = descParts.join(' · ')
        if (ev.summary) description = description ? `${description} — ${ev.summary}` : ev.summary
        const expiresDateUtc = this.shareExpirationDays === 'permanent'
          ? undefined
          : new Date(Date.now() + this.shareExpirationDays * 86400000).toISOString()

        // Resolve which file IDs to include.
        // If all sharable files are selected, send no fileIds (share-all fallback keeps future files included).
        const selectedIds = Array.from(this.shareSelectedFileIds)
        const isAllSelected = selectedIds.length === this.shareTotalFileCount
        const fileIdsPayload = isAllSelected ? undefined : selectedIds

        const res = await publicFilesApi.createPublicFileShare(companyId, {
          resourceId: this.eventToManage.id,
          resourceType: 'Event',
          title: titleParts.join(' — '),
          description: description || undefined,
          fileIds: fileIdsPayload,
          expiresDateUtc
        })
        this.existingShareId = res.data.shareId
        this.existingShareUrl = res.data.publicShareUrl
        this.existingShareQrCodeUrl = res.data.qrCodePublicUrl || null
        this.existingShareQrCodeSvgUrl = res.data.qrCodeSvgPublicUrl || null
        this.existingShareExpiresDateUtc = expiresDateUtc || null
        this.existingShareFileIds = fileIdsPayload || []
      } catch (e) {
        this.$toasted.error('Unable to create share link. Please try again.', { duration: 4000 })
      } finally {
        this.shareActionLoading = false
      }
    },

    async confirmRevokeShare () {
      this.shareActionLoading = true
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        await publicFilesApi.revokeShare(companyId, this.existingShareId)
        this.existingShareId = null
        this.existingShareUrl = null
        this.existingShareQrCodeUrl = null
        this.existingShareQrCodeSvgUrl = null
        this.existingShareExpiresDateUtc = null
        this.existingShareFileIds = []
        this.shareRevokeConfirming = false
        this.fileShareModalVisible = false
        this.$toasted.success('Share link deactivated.', { duration: 3000 })
      } catch (e) {
        this.$toasted.error('Unable to deactivate link. Please try again.', { duration: 4000 })
      } finally {
        this.shareActionLoading = false
      }
    },

    async createNewShareLink () {
      // Revoke the old share silently, then reset to the selection step
      // so the user can choose a new file selection + expiration.
      this.shareActionLoading = true
      try {
        const companyId = this.$store.state.userCurrentCompany && this.$store.state.userCurrentCompany.companyId
        if (this.existingShareId) {
          await publicFilesApi.revokeShare(companyId, this.existingShareId)
        }
        this.existingShareId = null
        this.existingShareUrl = null
        this.existingShareQrCodeUrl = null
        this.existingShareQrCodeSvgUrl = null
        this.existingShareExpiresDateUtc = null
        this.existingShareFileIds = []
        this.shareExpirationDays = 'permanent'
        this.shareRevokeConfirming = false
        this.shareIsReselecting = false
        // Reset to file-selection step and reload the tree
        this.shareSelectedFileIds = new Set()
        this.shareExpandedFolders = []
        this.shareFolderCache = {}
        this.shareModalStep = 'select'
        await this.loadShareFileTree()
        this.selectAllFiles()
      } catch (e) {
        // Proceed even if the revoke failed
      } finally {
        this.shareActionLoading = false
      }
    },

    copyFileShareUrl () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.existingShareUrl)
          .then(() => {
            this.shareCopyLabel = 'Copied!'
            setTimeout(() => { this.shareCopyLabel = 'Copy Link' }, 2000)
          })
          .catch(() => this.copyFileShareUrlFallback())
      } else {
        this.copyFileShareUrlFallback()
      }
    },

    copyFileShareUrlFallback () {
      if (this.$refs.shareUrlInput) {
        this.$refs.shareUrlInput.select()
        document.execCommand('copy')
        this.shareCopyLabel = 'Copied!'
        setTimeout(() => { this.shareCopyLabel = 'Copy Link' }, 2000)
      }
    }
  }
}
</script>

<style>
.ui.modals.active .modal {
  height: auto;
}
.input-upload {
  padding: 7px !important;
}
.no-images-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  border: 1px dashed #ccc;
  border-radius: 10px;
  color: #aaa;
  gap: 0.5rem;
}
.no-images-placeholder i {
  font-size: 1.75rem;
}
.image-list {
  column-count: 2;
  column-gap: 1rem;
}
@media screen and (max-width: 1199px) {
  .image-list {
    column-count: 4;
    column-gap: 1rem;
  }
}
@media screen and (max-width: 959px) {
  .image-list {
    column-count: 3;
    column-gap: 1rem;
  }
}
@media screen and (max-width: 767px) {
  .image-list {
    column-count: 2;
    column-gap: 1rem;
  }
}
.image-list .card {
  height: 90px;
  min-height: 90px;
  max-height: 90px;
  overflow: hidden;
  object-fit: cover;
  object-position: center center;
  padding: 0;
  position: relative;
  min-width: 100%;
  max-width: 100%;
}
.image-list .card img{
  object-fit: cover;
  height: 100%;
}
.no-documents:empty::after {
  content: "No Documents";
  display: block;
  padding: 3em;
  text-align: center;
  width: 100%;
  border: 1px dashed #ccc;
  border-radius: 10px;
  background: #f9f9f9;
  color: rgba(0, 0, 0, 0.5) !important;
}
.no-claims:empty::after {
  content: "No Claims";
  display: block;
  padding: 3em;
  text-align: center;
  width: 100%;
  border: 1px dashed #ccc;
  border-radius: 10px;
  background: #f9f9f9;
  color: rgba(0, 0, 0, 0.5) !important;
}
.custom-tabs .tab-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.custom-tabs .tab-content,
.custom-menu.menu > div {
  max-width: 1280px;
  margin: auto !important;
  border: none;
}
.container.flush {
  padding: 0 !important;
  margin: 0 !important;
}
.custom-tabs .nav-tabs {
  display: flex;
  justify-content: center;
  background-color: #122b41 !important;
  flex-wrap: nowrap;
}
.custom-tabs .nav-tabs .nav-link {
  color: #fff;
}
.custom-tabs .nav-tabs .nav-link:hover {
  border-color: transparent;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.custom-tabs .nav-tabs .nav-link.active,
.custom-tabs .nav-tabs .nav-link.active:hover {
    color: #495057;
    background-color: #f1f1f1;
    border-color: #dee2e6 #dee2e6 #f1f1f1;
}
.custom-menu {
  background-color: #122b41 !important;
}
.custom-menu h2,
.custom-tabs .tabular.menu > .item {
  color: #fff;
}
.custom-menu .close {
  font-size: 220%;
  text-shadow: none;
  color: rgba(255, 255, 255, 0.75);
}
.custom-tabs.sticky-tabs > div:first-child{
  position: sticky;
  top: 0px;
  height: 50px;
  z-index: 1;
  padding-top: 15px;
  background-color: #122b41!important;
}
.label {
  font-weight: 500;
}

.no-data {
  border: 1px dashed #ccc;
  border-radius: 10px;
  background: #f9f9f9;
}

.modal-drawer .modal-dialog{
    height: 100vh;
    margin-top: 0;
    margin-right: 0;
    position: fixed;
    right: 0;
    min-width: 500px;
}

.modal-drawer .modal-dialog.modal-lg{
    min-width: 800px;
}

.modal-drawer.fade .modal-dialog{
    transform: translate(2200px, 0);
    transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1);
}

.modal-drawer.show .modal-dialog{
    transform: none;
}

.modal-drawer .modal-dialog .modal-content{
    height: calc(100vh - 1.5em);
    max-height: 100vh;
    overflow: hidden; /* clip flex children to the fixed height so inner overflow-y: auto kicks in */
    display: flex;
    flex-direction: column;
}

/* Constrain the modal body so height:100% on the wizard child resolves correctly */
.modal-drawer .modal-dialog .modal-content > .modal-body {
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
}

@media screen and (max-width: 960px) {
  .modal-drawer .modal-dialog,
  .modal-drawer .modal-dialog.modal-lg{
    min-width: 650px;
  }
}

@media screen and (max-width: 767px) {
  .modal-drawer .modal-dialog,
  .modal-drawer .modal-dialog.modal-lg{
    min-width: 100%;
  }
}

.border-left-3 {
  border-left-width: 3px !important;
}

.resources-embedded .page {
  height: auto !important;
  overflow: visible !important;
}

.resources-embedded .form-container {
  height: auto !important;
  overflow-y: visible !important;
  overflow-x: visible !important;
}
</style>